module.exports = __webpack_public_path__ + "static/media/image8_deu.b6cba139.png";